export default [
    {
      title: "No",
      key: "number",
      dataIndex: "number",
      scopedSlots: { customRender: "number" }
    },
    {
      title: "Nama",
      key: "name",
      scopedSlots: { customRender: "name" }
    },
    {
      title: "Member",
      key: "member",
      scopedSlots: { customRender: "member" }
    },
    {
      title: "Referral Share",
      key: "referral",
      scopedSlots: { customRender: "referral" }
    },
    {
      title: "Income",
      key: "income",
      scopedSlots: { customRender: "income" }
    },
    {
      title: "Posisi",
      key: "posisi",
      scopedSlots: { customRender: "posisi" }
    },
    {
      title: "Aksi",
      key: "action",
      scopedSlots: { customRender: "action" }
    }
  ];
  